export const EVENT_ADD = "add";
export const EVENT_DELETE = "delete";
export const EVENT_RESCHEDULE = "reschedule";
